

























































import { Component, Vue } from 'vue-property-decorator'
import FileSaver from 'file-saver'

import Uploader from '@/components/Uploader.vue'
import {Problem} from '@/models'

@Component({
  components: {
    Uploader
  }
})
export default class LayoutDefault extends Vue {
  private $q: any
  private leftDrawerOpen: boolean = this.$q.platform.is.desktop

  private get problems(): Problem[] {
    return this.$store.getters.problems
  }

  private jumpToProblem(fileId: string): void {
    window.location.hash = fileId
  }

  private async download(): Promise<void> {
    const buffer = await this.$store.state.problemCollection.generateMarkdownZip()
    FileSaver.saveAs(new Blob([buffer]), 'exapunks-solutions.zip')
  }
}
